import ResourceApi from '../ResourceApi';

const JobResource = {
  index: async (params = {}) => (await ResourceApi.get('/resource/jobs', params)).data,
  get: async (job, params = {}) => (await ResourceApi.get(`/resource/jobs/${job}`, params)).data,
  put: async (job, params = {}) => (await ResourceApi.put(`/resource/jobs/${job}`, params)).data,
  post: async (params = {}) => (await ResourceApi.post('/resource/jobs', params)).data,
};

export default JobResource;
